import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getAmplitudeOfferSelectItemEventProperties} from "./get_amplitude_offer_select_item_event_properties";

export interface ITrackAmplitudeOfferSelectItemParams {
    offer: IOfferBoxOffer;
    index: number;
}

export const trackAmplitudeOfferSelectItem = (params: ITrackAmplitudeOfferSelectItemParams) => {
    trackAmplitudeEvent("select_item", getAmplitudeOfferSelectItemEventProperties(params));
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getAmplitudeOfferSelectItemEventProperties} from "./get_amplitude_offer_select_item_event_properties";

export interface ITrackAmplitudeOfferSelectItemParams {
    offer: IOfferBoxOffer;
    index: number;
}

export const trackAmplitudeOfferSelectItem = (params: ITrackAmplitudeOfferSelectItemParams) => {
    trackAmplitudeEvent("select_item", getAmplitudeOfferSelectItemEventProperties(params));
};
